export const UNAUTHORIZE_MESSAGE = "UNAUTHORIZE_MESSAGE";
export const INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR";
export const UNHANDLE_EXCEPTION = "UNHANDLE_EXCEPTION";
export const SEE_IN_LOG = "SEE_IN_LOG";